import Manage from "..";
import { useEffect, useState } from "react";
import StationsPannel from "./components/StationsPanel";
import { IoLocationOutline } from "react-icons/io5";
import CreateWrapper from "./components/CreateWrapper";
import { FiEdit, FiMoreVertical } from "react-icons/fi";
import { Popover } from "antd";
import { BsTrash } from "react-icons/bs";
import fetchAllSites from "../../../services/fetchAllSites";

export default function AllSites() {
  const [sites, setSites] = useState<any>([]);
  const [dealers, setDealers] = useState<any>([]);

  const [showStations, setShowStations] = useState(false);
  const [selected, setSelected] = useState({});

  const handleFetchAllSites = async () => {
    const data = await fetchAllSites();
    const sites = data?.payload.filter((item: any) => !item.isDealer);
    const dealers = data?.payload.filter((item: any) => item.isDealer);
    setDealers(dealers);
    setSites(sites);
  };

  useEffect(() => {
    handleFetchAllSites();
  }, []);

  const content = (
    <div className="flex flex-col justify-start items-start">
      <button
        onClick={() => {}}
        className="flex justify-center items-center text-gray-700 cursor-pointer hover:text-red-500 mb-2"
      >
        <span>
          <FiEdit />
        </span>{" "}
        <span className="ml-2">Update</span>
      </button>
      <button
        onClick={() => {}}
        className="flex justify-center items-center text-gray-700 cursor-pointer hover:text-red-500 mb-2"
      >
        <span>
          <BsTrash />
        </span>
        <span className="ml-2">Delete</span>
      </button>
    </div>
  );

  return (
    <Manage
      title={"Toyota Sites"}
      subtitle={"All"}
      description={"List of all Toyota Tanzania sites"}
      actions={<CreateWrapper />}
    >
      <div className="grid grid-cols-12 gap-2 m-4">
        {sites?.map((site: any) => (
          <div className="col-span-12 sm:col-span-3 md:col-span-2 border p-4 rounded-lg hover:bg-gray-50">
            <div className="flex flex-right justify-end p-1">
              <div className="">
                <Popover
                  placement="bottom"
                  content={content}
                  title={`${site?.name}`}
                >
                  <FiMoreVertical />
                </Popover>
              </div>
            </div>

            <div
              onClick={() => {
                setShowStations(true);
                setSelected(site);
              }}
              className="flex flex-col justify-center items-center  cursor-pointer"
            >
              <div className="h-24 w-24 rounded-full bg-gray-100 flex justify-center items-center">
                <IoLocationOutline size={30} />
              </div>
              <div className="my-4">{site?.name}</div>
              <button
                onClick={() => {
                  setShowStations(true);
                  setSelected(site);
                }}
                className="border p-2 rounded-lg"
              >
                <span className="font-bold mr-1">{site?.stations?.length}</span>
                Stations
              </button>
              <div className="mt-1">
                {site?.isAutoInc ? (
                  <div
                    className="text-xs font-bold"
                    style={{ color: "#194276" }}
                  >
                    Auto Inc
                  </div>
                ) : (
                  <div
                    className="text-xs font-bold"
                    style={{ color: "#e50000" }}
                  >
                    Toyota
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
        <StationsPannel
          isVisible={showStations}
          setShowStations={setShowStations}
          selected={selected}
        />
      </div>

      <div className="border-b p-4 flex justify-between items-center h-18">
        <div className="">
          <span className="text-lg font-bold">Dealers : </span>
          <span>All</span>
          <div className="">List of service 3rd part dealers</div>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-2 m-4">
        {dealers?.map((site: any) => (
          <div className="col-span-12 sm:col-span-3 md:col-span-2 border p-4 rounded-lg">
            <div className="flex flex-right justify-end p-1">
              <div className="">
                <Popover
                  placement="bottom"
                  content={content}
                  title={`${site?.name}`}
                >
                  <FiMoreVertical />
                </Popover>
              </div>
            </div>

            <div className="flex flex-col justify-center items-center cursor-default">
              <div className="my-4">{site?.name}</div>
              <button className="border p-2 rounded-lg">{site.region}</button>
            </div>
            <div className="flex justify-center my-2">
              {site?.isDealer && (
                <div className="text-xs font-bold" style={{ color: "#E50000" }}>
                  Dealer
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </Manage>
  );
}
